var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroCircularShapeBuildex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 773,
    height: 773,
    viewBox: "0 0 773 773",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "hero-circular-shape-buildex",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.122164 504.09C64.8206 503.976 117.375 451.238 117.262 386.295C117.148 321.353 64.4101 268.798 -0.532628 268.911C-65.4753 269.025 -118.03 321.763 -117.917 386.706C-117.803 451.648 -65.0649 504.203 -0.122164 504.09ZM112.149 386.304C112.258 448.423 61.988 498.869 -0.131087 498.977C-62.2503 499.086 -112.696 448.816 -112.804 386.697C-112.912 324.578 -62.6429 274.132 -0.523705 274.024C61.5954 273.915 112.041 324.185 112.149 386.304Z",
    fill: "url(#paint0_angular_1061_58352)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.088702 523.262C75.4425 523.13 136.566 461.793 136.434 386.262C136.302 310.731 74.9651 249.607 -0.56609 249.739C-76.0973 249.871 -137.221 311.208 -137.089 386.739C-136.957 462.27 -75.62 523.394 -0.088702 523.262ZM131.321 386.271C131.448 458.978 72.61 518.022 -0.0976251 518.149C-72.8052 518.276 -131.849 459.438 -131.976 386.73C-132.103 314.023 -73.2648 254.979 -0.557167 254.852C72.1505 254.725 131.195 313.563 131.321 386.271Z",
    fill: "url(#paint1_angular_1061_58352)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.606 386.228C155.756 472.348 86.0645 542.284 -0.0552402 542.434C-86.1749 542.584 -156.111 472.892 -156.261 386.773C-156.411 300.653 -86.7192 230.717 -0.599552 230.567C85.5202 230.417 155.456 300.109 155.606 386.228ZM-0.0641633 537.321C83.2319 537.176 150.639 469.533 150.494 386.237C150.348 302.941 82.7055 235.534 -0.590629 235.68C-83.8868 235.825 -151.294 303.468 -151.148 386.764C-151.003 470.06 -83.3603 537.467 -0.0641633 537.321Z",
    fill: "url(#paint2_angular_1061_58352)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.778 386.195C174.947 482.903 96.6864 561.437 -0.0217784 561.606C-96.73 561.775 -175.264 483.514 -175.433 386.806C-175.602 290.098 -97.3412 211.564 -0.633014 211.395C96.0752 211.226 174.61 289.487 174.778 386.195ZM-0.0307015 556.494C93.8539 556.33 169.83 480.088 169.666 386.204C169.502 292.319 93.2605 216.344 -0.624091 216.507C-94.5087 216.671 -170.484 292.913 -170.32 386.797C-170.157 480.682 -93.9153 556.657 -0.0307015 556.494Z",
    fill: "url(#paint3_angular_1061_58352)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.95 386.161C194.138 493.458 107.308 580.591 0.0116834 580.778C-107.285 580.966 -194.418 494.136 -194.605 386.84C-194.793 279.543 -107.963 192.41 -0.666476 192.223C106.63 192.035 193.763 278.865 193.95 386.161ZM0.00276028 575.666C104.476 575.483 189.02 490.643 188.838 386.17C188.656 281.697 103.816 197.153 -0.657552 197.335C-105.131 197.518 -189.675 282.358 -189.493 386.831C-189.31 491.304 -104.47 575.848 0.00276028 575.666Z",
    fill: "url(#paint4_angular_1061_58352)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0451452 599.95C117.93 599.745 213.328 504.013 213.123 386.128C212.917 268.243 117.185 172.845 -0.699937 173.05C-118.585 173.256 -213.983 268.988 -213.777 386.873C-213.572 504.758 -117.84 600.156 0.0451452 599.95ZM208.01 386.137C208.211 501.198 115.098 594.637 0.0362221 594.838C-115.025 595.039 -208.464 501.926 -208.665 386.864C-208.866 271.803 -115.753 178.364 -0.691014 178.163C114.371 177.962 207.809 271.075 208.01 386.137Z",
    fill: "url(#paint5_angular_1061_58352)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.295 386.094C232.519 514.568 128.552 618.898 0.078607 619.123C-128.395 619.347 -232.725 515.38 -232.95 386.906C-233.174 258.433 -129.207 154.103 -0.733399 153.878C127.74 153.654 232.071 257.621 232.295 386.094ZM0.0696838 614.01C125.72 613.791 227.401 511.753 227.182 386.103C226.963 260.453 124.926 158.772 -0.724476 158.991C-126.375 159.21 -228.056 261.248 -227.837 386.898C-227.618 512.548 -125.58 614.229 0.0696838 614.01Z",
    fill: "url(#paint6_angular_1061_58352)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.112069 638.295C139.174 638.052 251.71 525.123 251.467 386.061C251.224 246.999 138.295 134.463 -0.766861 134.706C-139.829 134.949 -252.364 247.878 -252.122 386.94C-251.879 526.002 -138.95 638.537 0.112069 638.295ZM246.354 386.07C246.592 522.308 136.342 632.944 0.103146 633.182C-136.135 633.42 -246.771 523.17 -247.009 386.931C-247.247 250.692 -136.996 140.057 -0.757938 139.819C135.481 139.581 246.117 249.831 246.354 386.07Z",
    fill: "url(#paint7_angular_1061_58352)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.639 386.028C270.9 535.678 149.796 657.206 0.145531 657.467C-149.505 657.728 -271.033 536.624 -271.294 386.973C-271.555 237.323 -150.451 115.795 -0.800323 115.534C148.85 115.273 270.378 236.377 270.639 386.028ZM0.136607 652.354C146.964 652.098 265.783 532.864 265.527 386.036C265.27 239.209 146.036 120.39 -0.7914 120.647C-147.618 120.903 -266.438 240.137 -266.181 386.964C-265.925 533.792 -146.69 652.611 0.136607 652.354Z",
    fill: "url(#paint8_angular_1061_58352)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.178992 676.639C160.418 676.359 290.091 546.233 289.811 385.994C289.532 225.755 159.405 96.0822 -0.833784 96.3619C-161.073 96.6415 -290.746 226.768 -290.466 387.007C-290.186 547.246 -160.06 676.919 0.178992 676.639ZM284.699 386.003C284.973 543.419 157.586 671.252 0.170069 671.527C-157.245 671.801 -285.079 544.413 -285.353 386.998C-285.628 229.582 -158.24 101.749 -0.824861 101.474C156.591 101.2 284.424 228.587 284.699 386.003Z",
    fill: "url(#paint9_angular_1061_58352)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.983 385.961C309.282 556.788 171.04 695.513 0.212454 695.811C-170.615 696.109 -309.34 557.868 -309.638 387.04C-309.936 216.213 -171.695 77.4879 -0.867246 77.1897C169.96 76.8916 308.685 215.133 308.983 385.961ZM0.203531 690.699C168.208 690.405 304.164 553.974 303.871 385.97C303.578 217.966 167.146 82.009 -0.858323 82.3023C-168.862 82.5955 -304.819 219.027 -304.526 387.031C-304.232 555.035 -167.8 690.992 0.203531 690.699Z",
    fill: "url(#paint10_angular_1061_58352)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.245916 714.983C181.662 714.667 328.472 567.343 328.156 385.927C327.839 204.511 180.515 57.7009 -0.900708 58.0175C-182.317 58.3341 -329.127 205.658 -328.81 387.074C-328.494 568.49 -181.17 715.3 0.245916 714.983ZM323.043 385.936C323.355 564.529 178.83 709.559 0.236993 709.871C-178.356 710.183 -323.386 565.657 -323.698 387.065C-324.009 208.472 -179.484 63.4418 -0.891785 63.1301C177.701 62.8184 322.731 207.344 323.043 385.936Z",
    fill: "url(#paint11_angular_1061_58352)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.328 385.894C347.663 577.898 192.284 733.82 0.279378 734.156C-191.725 734.491 -347.647 579.112 -347.982 387.107C-348.318 195.103 -192.939 39.1805 -0.93417 38.8454C191.07 38.5103 346.993 193.889 347.328 385.894ZM0.270455 729.043C189.451 728.713 342.545 575.084 342.215 385.903C341.885 196.722 188.256 43.6278 -0.925247 43.958C-190.106 44.2882 -343.2 197.917 -342.87 387.098C-342.54 576.279 -188.911 729.373 0.270455 729.043Z",
    fill: "url(#paint12_angular_1061_58352)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.31284 753.328C202.906 752.974 366.853 588.453 366.5 385.86C366.146 183.267 201.625 19.3196 -0.967632 19.6732C-203.561 20.0268 -367.508 184.548 -367.155 387.141C-366.801 589.734 -202.28 753.681 0.31284 753.328ZM361.387 385.869C361.736 585.639 200.073 747.866 0.303916 748.215C-199.466 748.564 -361.693 586.901 -362.042 387.132C-362.391 187.362 -200.728 25.1345 -0.958709 24.7858C198.811 24.4372 361.039 186.1 361.387 385.869Z",
    fill: "url(#paint13_angular_1061_58352)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.672 385.827C386.044 599.008 213.528 772.128 0.346301 772.5C-212.835 772.872 -385.955 600.356 -386.327 387.174C-386.699 173.993 -214.183 0.873138 -1.00109 0.501065C212.18 0.128993 385.3 172.645 385.672 385.827ZM0.337378 767.387C210.695 767.02 380.927 596.194 380.559 385.836C380.192 175.478 209.366 5.24652 -0.99217 5.61367C-211.35 5.98081 -381.581 176.807 -381.214 387.165C-380.847 597.523 -210.021 767.754 0.337378 767.387Z",
    fill: "url(#paint14_angular_1061_58352)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_angular_1061_58352",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.5) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#00318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#0B5CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00318C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroCircularShapeBuildex);
export default __webpack_public_path__ + "static/media/hero-circular-shape-buildex.4928e8c62be4db3014c9654a378981ab.svg";
export { ForwardRef as ReactComponent };